import CryptoJS from 'crypto-js';
import { LOCAL_STORAGE_SECRET_KEY } from '../constants/Constants';

export const getLocalStorageItem = (key) => {
  try {
    const encrypted = localStorage.getItem(key);
    if (encrypted === null) {
      return undefined;
    }
    const decrypted = CryptoJS.AES.decrypt(
      encrypted,
      LOCAL_STORAGE_SECRET_KEY,
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch {
    return undefined;
  }
};

export const setLocalStorageItem = (key, value) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      LOCAL_STORAGE_SECRET_KEY,
    ).toString();
    localStorage.setItem(key, encrypted);
  } catch (error) {
    return error;
  }
};

export function removeLocalStorageItem(key) {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    return error;
  }
}
